import axios from "axios";
import { domain } from "../Links/Links";
import { getCookie } from "../../App";

export async function checkoutRequest(
  setCheckoutRequestStatus,
  setCheckoutStatus,
) {
  setCheckoutRequestStatus(true);
  console.log(getCookie("csrf_token"));
  const response = await axios.post(
    domain + "/checkout/",
    {},
    {
      withCredentials: true,
      headers: {
        "X-CSRFToken": getCookie("csrf_token"),
      },
    },
  );

  console.log(response.data);

  if (response.data.ok == true) {
    setCheckoutStatus("ok");
    setCheckoutRequestStatus(false);
  } else if (
    response.data.insufficient_balance == true
  ) {
    setCheckoutStatus("insufficient_balance");
    setCheckoutRequestStatus(false);
  } else if (
    response.data.error == true
  ) {
    setCheckoutStatus("error");
    setCheckoutRequestStatus(false);
  }
}
